import { render, staticRenderFns } from "./addAdminSubmit.vue?vue&type=template&id=6a29f106&scoped=true&"
import script from "./addAdminSubmit.vue?vue&type=script&lang=js&"
export * from "./addAdminSubmit.vue?vue&type=script&lang=js&"
import style0 from "./addAdminSubmit.vue?vue&type=style&index=0&id=6a29f106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29f106",
  null
  
)

export default component.exports